import React, { Component, useEffect, useState } from 'react';
import configData from '../configData.json';
import Spinner from 'react-bootstrap/Spinner';
import Select, { components } from 'react-select';
import { toDate } from 'date-fns';
import SelectSearch, { fuzzySearch } from "react-select-search";
import DatePicker from 'react-date-picker';
import moment from 'moment';

import "../style/select-search.css";
import { isDisabled } from '@testing-library/user-event/dist/utils';
import FormCheckInput from 'react-bootstrap/esm/FormCheckInput';

export default function F68RightFilterContent(props) {

    // const [toDate, setToDate] = useState(new Date());
    const [currentDate, setCurrentDate] = useState(new Date());
    // const [toDate, setToDate] = useState(new Date(currentDate.getTime() - 1 * 24 * 60 * 60 * 1000));
    // const [fromDate, setFromDate] = useState(new Date(toDate.getFullYear(), 0, 1, 23, 59, 59));
    // const [fromDate, setFromDate] = useState(new Date(toDate.getTime() - 7 * 24 * 60 * 60 * 1000));
    const [toDate, setToDate] = useState(new Date(currentDate.getTime() - 1 * 24 * 60 * 60 * 1000));
    const [fromDate, setFromDate] = useState(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000));
    const [toShipDate, setToShipDate] = useState(new Date());
    const [fromShipDate, setFromShipDate] = useState(new Date('01/01/1990'));
    const defaultFromValue = moment(fromDate).format().substring(0, 10);
    const defaultToValue = moment(toDate).format().substring(0, 10);

    const [owners, setOwners] = useState([]);
    const [customers, setCustomers] = useState([]);

    // Division
    const [divisionOptions, setDivisionOptions] = useState([]);
    // const [selectedDivision, setSelectedDivision] = useState(0);
    const [selectedDivision, setSelectedDivision] = useState([]);

    // Region
    const [regionOptions, setRegionOptions] = useState([]);
    // const [selectedRegion, setSelectedRegion] = useState(0);
    const [selectedRegion, setSelectedRegion] = useState([]);

    // Branch
    const [branchOptions, setBranchOptions] = useState([]);
    // const [selectedBranch, setSelectedBranch] = useState(0);
    const [selectedBranch, setSelectedBranch] = useState([]);

    const [selectedOwner, setSelectedOwner] = useState(0);
    const [selectedCust, setSelectedCust] = useState(0);

    const [selectedReportName, setSelectedReportName] = useState('F068');
    const [selectedExcludeRateAndRouteAnalysis, setSelectedExcludeRateAndRouteAnalysis] = useState('Y');
    const [selectedFromDate, setSelectedFromDate] = useState(moment(fromDate).format().substring(0, 10));
    const [selectedToDate, setSelectedToDate] = useState(moment(toDate).format().substring(0, 10));
    const [selectedFromShipDate, setSelectedFromShipDate] = useState(moment(fromShipDate).format().substring(0, 10));
    const [selectedToShipDate, setSelectedToShipDate] = useState(moment(toShipDate).format().substring(0, 10));
    const [ownerLoading, isOwnerLoading] = useState(false);
    const [customerLoading, isCustomerLoading] = useState(false);
    const [divisionLoading, isDivisionLoading] = useState(false);
    const [regionLoading, isRegionLoading] = useState(false);
    const [branchLoading, isBranchLoading] = useState(false);


    // multiselect
    const [selectedOptions, setSelectedOptions] = useState([]);

    const InputOption = ({
        getStyles,
        Icon,
        isDisabled,
        isFocused,
        isSelected,
        children,
        innerProps,
        ...rest
    }) => {
        const [isActive, setIsActive] = useState(false);
        const onMouseDown = () => setIsActive(true);
        const onMouseUp = () => setIsActive(false);
        const onMouseLeave = () => setIsActive(false);

        // styles
        let bg = "transparent";
        if (isFocused) bg = "#eee";
        if (isActive) bg = "#B2D4FF";

        const style = {
            alignItems: "center",
            backgroundColor: bg,
            color: "inherit",
            display: "flex "
        };

        // prop assignment
        const props = {
            ...innerProps,
            onMouseDown,
            onMouseUp,
            onMouseLeave,
            style
        };

        return (
            <components.Option
                {...rest}
                isDisabled={isDisabled}
                isFocused={isFocused}
                isSelected={isSelected}
                getStyles={getStyles}
                innerProps={props}
            >
                <input type="checkbox" style={{ marginRight: '5px' }} checked={isSelected} />
                {children}
            </components.Option>
        );
    };
    // multiselect end

    const LoadOwners = async () => {
        // debugger;
        isOwnerLoading(true);
        const custUrl = `${configData.BASE_APP_URL}Owner/GetOwnerList`;
        await fetch(custUrl,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            }
        ).then(resp => resp.json())
            .then(resp => {
                let ownerOptions = [];
                resp.map(owner => {
                    const own = {
                        "name": owner.ownerName,
                        "value": owner.ownerID
                    }
                    ownerOptions = [...ownerOptions, own];
                })
                const defaultOwner = {
                    "name": "--Select A Value--",
                    "value": 0
                }
                ownerOptions.unshift(defaultOwner);
                setOwners(ownerOptions)
            })
        isOwnerLoading(false);
        LoadCustomer(0);

        // setIsDisabled(props.isDisabled);
    }

    const LoadCustomer = async (ownerKey) => {
        // debugger;
        setSelectedOwner(ownerKey);
        isDivisionLoading(true);
        const custUrl = `${configData.BASE_APP_URL}Customer/GetCustomerList/${ownerKey}`;
        await fetch(custUrl,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            }
        ).then(resp => resp.json())
            .then(resp => {
                let customerOptions = [];
                resp.map(customer => {
                    const cust = {
                        "name": customer.customerName,
                        "value": customer.customerKey
                    }
                    customerOptions = [...customerOptions, cust];
                })
                const defaultCustomer = {
                    "name": "--Select A Value--",
                    "value": 0
                }
                customerOptions.unshift(defaultCustomer);
                setCustomers(customerOptions)
            })
        isDivisionLoading(false);
        // setIsDisabled(props.isDisabled);
    }

    const LoadDivisionMulti = async (customerKey) => {
        isDivisionLoading(true);
        setSelectedCust(customerKey);
        const URL = `${configData.BASE_APP_URL}Division/GetDivisionList/${customerKey}`;
        await fetch(URL,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            })
            .then(resp => resp.json())
            .then(resp => {
                let divisionOptions = [];
                resp.map((division) => {
                    const carr = {
                        "label": division.divisionName,
                        "value": division.divisionKey
                    }
                    divisionOptions = [...divisionOptions, carr];

                })
                // const defaultCarrier = {
                //     "name": "-- Select A Value --",
                //     "value": -1
                // }
                // carrierOptions.unshift(defaultCarrier);
                if (customerKey > 0) {
                    const allDivision = {
                        "label": "-- ALL DIVISIONS  --",
                        "value": -1
                    }
                    divisionOptions.unshift(allDivision);
                    debugger;
                    setSelectedDivision([allDivision]);
                }
                // else {
                //     const defaultDivision = {
                //         "label": "-- Select A Value --",
                //         "value": 0
                //     }
                //     divisionOptions.unshift(defaultDivision);
                // }
                setDivisionOptions(divisionOptions)
            })
        isDivisionLoading(false);
    }


    const LoadRegionMulti = async (customerKey, divisionKeys) => {
        debugger;
        isRegionLoading(true);
        // setSelectedCust(customerKey);
        const URL = `${configData.BASE_APP_URL}Region/GetRegion/${customerKey}/${divisionKeys}`;
        await fetch(URL,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            })
            .then(resp => resp.json())
            .then(resp => {
                let regionOptions = [];
                resp.map((region) => {
                    const regn = {
                        "label": region.regionDesc,
                        "value": region.regionKey
                    }
                    regionOptions = [...regionOptions, regn];

                })
                // const defaultCarrier = {
                //     "name": "-- Select A Value --",
                //     "value": -1
                // }
                // carrierOptions.unshift(defaultCarrier);

                const allRegions = {
                    "label": "-- ALL REGIONS  --",
                    "value": -1
                }
                regionOptions.unshift(allRegions);
                setSelectedRegion([allRegions]); // Set "All regions" as selected

                // else {
                //     const defaultRegion = {
                //         "label": "-- Select A Value --",
                //         "value": 0
                //     }
                //     regionOptions.unshift(defaultRegion);
                // }
                setRegionOptions(regionOptions)
            })
        isRegionLoading(false);
    }

    const LoadBranchMulti = async (customerKey, divisionKeys, regionKeys) => {
        debugger;
        isBranchLoading(true);
        // setSelectedCust(customerKey);
        const URL = `${configData.BASE_APP_URL}Branch/GetBranch/${customerKey}/${divisionKeys}/${regionKeys}`;
        await fetch(URL,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            })
            .then(resp => resp.json())
            .then(resp => {
                let branchOptions = [];
                resp.map((branch) => {
                    const bran = {
                        "label": branch.branchDesc,
                        "value": branch.branchKey
                    }
                    branchOptions = [...branchOptions, bran];

                })
                // const defaultCarrier = {
                //     "name": "-- Select A Value --",
                //     "value": -1
                // }
                // carrierOptions.unshift(defaultCarrier);
                const allBranches = {
                    "label": "-- ALL BRANCHES --",
                    "value": -1
                }
                branchOptions.unshift(allBranches);
                setSelectedBranch([allBranches]);

                // else {
                //     const defaultBranch = {
                //         "label": "-- Select A Value --",
                //         "value": 0
                //     }
                //     branchOptions.unshift(defaultBranch);
                // }
                setBranchOptions(branchOptions)
            })
        isBranchLoading(false);
    }

    const LoadBills = async (e) => {
        debugger;
        e.preventDefault();
        if (selectedOwner === 0) {
            document.getElementById("owner-error").innerHTML = "Owner is a Required Field, a selection must be made";
            return;
        }
        else {
            document.getElementById("owner-error").innerHTML = "";
        }

        if (selectedCust === 0) {
            document.getElementById("customer-error").innerHTML = "Customer is a Required Field, a selection must be made";
            return;
        }
        else {
            document.getElementById("customer-error").innerHTML = "";
        }

        if (selectedDivision.length === 0) {
            document.getElementById("division-error").innerHTML = "Division is not selected";
            return;
        }
        else {
            document.getElementById("division-error").innerHTML = "";
        }

        if (selectedRegion.length === 0) {
            document.getElementById("region-error").innerHTML = "Region is not selected";
            return;
        }
        else {
            document.getElementById("region-error").innerHTML = "";
        }

        if (selectedBranch.length === 0) {
            document.getElementById("branch-error").innerHTML = "Branch is not selected";
            return;
        }
        else {
            document.getElementById("branch-error").innerHTML = "";
        }

        var today = new Date();
        var myFromShipDate = new Date(selectedFromShipDate);
        // console.log(today.toDateString());
        // console.log(myfromdate.toDateString());
        if (myFromShipDate.toString() == 'Invalid Date') {
            document.getElementById("fesd-error").innerHTML = 'Invalid Date'
            return;
        }


        if (myFromShipDate > today) {
            console.log(selectedFromShipDate);
            return;
        }

        var myToShipDate = new Date(selectedToShipDate);

        if (myToShipDate.toString() == 'Invalid Date') {
            document.getElementById("tesd-error").innerHTML = 'Invalid Date'
            return;
        }

        // if (myToShipDate > today) {
        //     console.log(selectedToShipDate);
        //     return;
        // }

        // if (myFromShipDate > myToShipDate) {
        //     return;
        // }

        debugger;
        // props.onSearchClick(selectedCust, selectedDivision, selectedRegion, selectedBranch, selectedFromDate, selectedToDate, selectedFromShipDate, selectedToShipDate, selectedReportName, selectedExcludeRateAndRouteAnalysis);
        let selectedDivisionMultiValue = selectedDivision.map((opt) => opt.value).join(', ');
        let selectedRegionMultiValue = selectedRegion.map((opt) => opt.value).join(', ');
        let selectedBranchMultiValue = selectedBranch.map((opt) => opt.value).join(', ');
        props.onSearchClick(selectedCust, selectedDivisionMultiValue, selectedRegionMultiValue, selectedBranchMultiValue, selectedFromDate, selectedToDate, selectedFromShipDate, selectedToShipDate, selectedReportName, selectedExcludeRateAndRouteAnalysis);
    }


    useEffect(() => {
        // debugger;
        LoadOwners();
        // LoadCustomer();
        // const inputPstNoOfwk = document.querySelector('#pastnumofweek');
    }, [])

    const onOwnerSelect = (e) => {
        debugger;
        var ownerkey = e;
        if (ownerkey > 0) {
            document.getElementById("owner-error").innerHTML = "";
        }
        LoadCustomer(e);
        setSelectedCust(0);

        setDivisionOptions([]);
        setSelectedDivision([]);

        setRegionOptions([]);
        setSelectedRegion([]);

        setBranchOptions([]);
        setSelectedBranch([]);

        // props.onCustomerChange(custkey);

    };

    const onCustomerSelect = (e) => {

        var custkey = e;
        if (custkey > 0) {
            document.getElementById("customer-error").innerHTML = "";
        }

        debugger;

        setSelectedCust(e);
        if (e == 0) {
            setDivisionOptions([]);
            setSelectedDivision([]);

            setRegionOptions([]);
            setSelectedRegion([]);

            setBranchOptions([]);
            setSelectedBranch([]);
        }
        else {
            LoadDivisionMulti(e);
            LoadRegionMulti(e, -1);
            LoadBranchMulti(e, -1, -1);
        }
    };

 

    const selectFromDate = (e) => {
        debugger;
        const formattedFromDate = e.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
        const formattedToDate = toDate.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
        var today = new Date();
        const formattedTodayDate = today.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });

        if (new Date(formattedFromDate) > new Date(formattedTodayDate)) {
            // document.getElementById("error").innerHTML = "From Entry Date is greater than To Entry Date";
            document.getElementById("fed-error").innerHTML = "From Entry Date is greater than Current Date";
            // return;
        }
        else if (new Date(formattedFromDate) > new Date(formattedToDate)) {
            // document.getElementById("error").innerHTML = "From Entry Date is greater than To Entry Date";
            document.getElementById("fed-error").innerHTML = "From Entry Date is greater than To Entry Date";
            // return;
        }
        else {
            document.getElementById("fed-error").innerHTML = "";
            document.getElementById("ted-error").innerHTML = "";
        }
        setFromDate(e);
        setSelectedFromDate(moment(e).format().substring(0, 10))

    };

    const selectToDate = (e) => {
        // debugger;

        // var toDateString = e.toLocaleDateString();
        // const afterLastSlash = toDateString.substring(toDateString.lastIndexOf('/') + 1)
        // console.log(afterLastSlash);

        // if (afterLastSlash.length === 4) {
        // }
        debugger;
        const formattedFromDate = fromDate.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
        const formattedToDate = e.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
        var today = new Date();
        const formattedTodayDate = today.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });



        if (new Date(formattedToDate) > new Date(formattedTodayDate)) {
            // document.getElementById("error").innerHTML = "From Entry Date is greater than To Entry Date";
            document.getElementById("ted-error").innerHTML = "To Entry Date is greater than Current Date";
            // return;
        }
        else if (new Date(formattedToDate) < new Date(formattedFromDate)) {
            // document.getElementById("error").innerHTML = "From Entry Date is greater than To Entry Date";
            document.getElementById("ted-error").innerHTML = "To Entry Date is less than From Entry Date";
            // return;
        }
        else {
            document.getElementById("fed-error").innerHTML = "";
            document.getElementById("ted-error").innerHTML = "";
        }
        setToDate(e);
        setSelectedToDate(moment(e).format().substring(0, 10))


    };

    const selectFromShipDate = (e) => {
        // debugger;
        var today = new Date();
        if (e > today) {
            // document.getElementById("error").innerHTML = "From Entry Date is greater than To Entry Date";
            document.getElementById("fesd-error").innerHTML = "From Ship Date is greater than Current Date";
            // return;
        }
        else if (e > toShipDate) {
            // document.getElementById("error").innerHTML = "From Entry Date is greater than To Entry Date";
            document.getElementById("fesd-error").innerHTML = "From Ship Date is greater than To Ship Date";
            // return;
        }
        else {
            document.getElementById("fesd-error").innerHTML = "";
        }
        setFromShipDate(e);
        setSelectedFromShipDate(moment(e).format().substring(0, 10))

    };

    const selectToShipDate = (e) => {
        // debugger;

        // var toDateString = e.toLocaleDateString();
        // const afterLastSlash = toDateString.substring(toDateString.lastIndexOf('/') + 1)
        // console.log(afterLastSlash);

        // if (afterLastSlash.length === 4) {
        // }

        var today = new Date();
        if (e > today) {
            // document.getElementById("error").innerHTML = "From Entry Date is greater than To Entry Date";
            document.getElementById("tesd-error").innerHTML = "To Ship Date is greater than Current Date";
            // return;
        }
        else if (e < fromShipDate) {
            // document.getElementById("error").innerHTML = "From Entry Date is greater than To Entry Date";
            document.getElementById("tesd-error").innerHTML = "To Ship Date is less than From Entry Date";
            // return;
        }
        else {
            document.getElementById("tesd-error").innerHTML = "";
        }
        setToShipDate(e);
        setSelectedToShipDate(moment(e).format().substring(0, 10))


    };

    const ClearFilter = async (e) => {
        // debugger;
        e.preventDefault();
        setSelectedOwner(0);
        setSelectedCust(0);
        setSelectedDivision(0);
        setSelectedRegion(0);
        setSelectedBranch(0);

        let customerOptions = [];
        const defaultCustomer = {
            "name": "-- Select A Value --",
            "value": 0
        }
        customerOptions.unshift(defaultCustomer);
        setCustomers(customerOptions);

        let divisionOptions = [];
        const defaultDivision = {
            "name": "-- Select A Value --",
            "value": 0
        }
        divisionOptions.unshift(defaultDivision);
        setDivisionOptions(divisionOptions);

        let regionOptions = [];
        const defaultRegion = {
            "name": "-- Select A Value --",
            "value": 0
        }
        regionOptions.unshift(defaultRegion);
        setRegionOptions(regionOptions);

        let branchOptions = [];
        const defaultBranch = {
            "name": "-- Select A Value --",
            "value": 0
        }
        branchOptions.unshift(defaultBranch);
        setBranchOptions(branchOptions);


        setToDate(new Date(currentDate.getTime() - 1 * 24 * 60 * 60 * 1000));
        setFromDate(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000))
        setToShipDate(new Date());
        setFromShipDate(new Date('01/01/1990'))

        debugger;
        let toDate = new Date(currentDate.getTime() - 1 * 24 * 60 * 60 * 1000);
        let fromDate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
        setSelectedToDate(moment(toDate).format().substring(0, 10));
        setSelectedFromDate(moment(fromDate).format().substring(0, 10));
    }

    const selectReportName = (e) => {
        setSelectedReportName(e.target.value)
    };


    const handleChange = (event) => {
        setSelectedExcludeRateAndRouteAnalysis(event.target.checked ? 'Y' : 'N');
    };

    const handleDivisionChange = (options) => {
        debugger;
        let filteredOptions = options;
        let selectedDivisionMultiValue;

        if (Array.isArray(options)) {
            if (options.length > 1 && options.some(opt => opt.value === -1)) {
                filteredOptions = options.filter(opt => opt.value !== -1);
            }

            selectedDivisionMultiValue = filteredOptions.map(opt => opt.value).join(', ');
            setSelectedDivision(filteredOptions);

            if (filteredOptions.length > 0) {
                document.getElementById("division-error").innerHTML = "";
                LoadRegionMulti(selectedCust, selectedDivisionMultiValue);
                LoadBranchMulti(selectedCust, selectedDivisionMultiValue, -1)
            }
            else {
                setRegionOptions([]);
                setBranchOptions([]);
                setSelectedRegion([]);
                setSelectedBranch([]);
            }
        }
    };

    const handleRegionChange = (options) => {
        let filteredOptions = options;
        let selectedRegionMultiValue;
        let selectedDivisionMultiValue = selectedDivision.map(opt => opt.value).join(', ');

        if (Array.isArray(options)) {
            if (options.length > 1 && options.some(opt => opt.value === -1)) {
                filteredOptions = options.filter(opt => opt.value !== -1);
            }

            selectedRegionMultiValue = filteredOptions.map(opt => opt.value).join(', ');
            setSelectedRegion(filteredOptions);

            if (filteredOptions.length > 0) {
                document.getElementById("region-error").innerHTML = "";
                LoadBranchMulti(selectedCust, selectedDivisionMultiValue, selectedRegionMultiValue)
            }
            else {
                setBranchOptions([]);
                setSelectedBranch([]);
            }
        }
    };

    const handleBranchChange = (options) => {
        let filteredOptions = options;
        if (Array.isArray(options)) {
            if (options.length > 1 && options.some(opt => opt.value === -1)) {
                filteredOptions = options.filter(opt => opt.value !== -1);
            }
            setSelectedBranch(filteredOptions);

        }
        document.getElementById("branch-error").innerHTML = "";
    };



    return (
        <>
            <div className="mb-2 form-field">
                <div id="owner-error" className="text-danger"></div>
                <label>Owner</label>
                <label id="owner-highlight" className="text-danger">*</label>
                <div>
                    <SelectSearch
                        id="ddnOwner"
                        name="ddnOwner"
                        // value={props.topFilterCustKey != '' ? props.topFilterCustKey : selectedCust}
                        value={selectedOwner}
                        options={owners}
                        onChange={onOwnerSelect}
                        search
                        filterOptions={fuzzySearch}

                    >
                    </SelectSearch>
                </div>
                {ownerLoading ? <Spinner className='spinner-border spinner-border-custom' animation="border" variant="primary" /> : ownerLoading}
            </div>
            <div className="mb-3 form-field">
                <div id="customer-error" className="text-danger"></div>
                <label>Customer</label>
                <label id="customer-highlight" className="text-danger">*</label>
                <div>
                    <SelectSearch
                        id="ddnCustomer"
                        name="ddnCustomer"
                        // value={props.topFilterCustKey != '' ? props.topFilterCustKey : selectedCust}
                        value={selectedCust}
                        options={customers}
                        onChange={onCustomerSelect}
                        search
                        filterOptions={fuzzySearch}

                    >
                    </SelectSearch>
                </div>
                {divisionLoading ? <Spinner className='spinner-border spinner-border-custom' animation="border" variant="primary" /> : divisionLoading}
            </div>

            {/* <div className="mb-2 form-field">
                <label>Division</label>
                <div>
                    <SelectSearch
                        id="ddnDivision"
                        name="ddnDivision"
                        value={selectedDivision}
                        options={divisions}
                        onChange={onDivisionSelect}
                        search
                        filterOptions={fuzzySearch}
                    >
                    </SelectSearch>
                </div>
            </div> */}

            <div className="mb-2 form-field">
                <div id="division-error" className="text-danger"></div>
                <label>Division</label>
                <label id="division-highlight" className="text-danger">*</label>
                <div>
                    <Select
                        defaultValue={[]}
                        value={selectedDivision}
                        isMulti
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        onChange={handleDivisionChange}
                        options={divisionOptions}
                        components={{
                            Option: InputOption
                        }}
                    />
                </div>
            </div>


            {/* <div className="mb-2 form-field">
                <label>Region</label>
                <div>
                    <SelectSearch
                        id="ddnRegion"
                        name="ddnRegion"
                        value={selectedRegion}
                        options={regions}
                        onChange={onRegionSelect}
                        search
                        filterOptions={fuzzySearch}
                    >
                    </SelectSearch>
                </div>
            </div> */}

            <div className="mb-2 form-field">
                <div id="region-error" className="text-danger"></div>
                <label>Region</label>
                <label id="region-highlight" className="text-danger">*</label>
                <div>
                    <Select
                        defaultValue={[]}
                        value={selectedRegion}
                        isMulti
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        onChange={handleRegionChange}
                        options={regionOptions}
                        components={{
                            Option: InputOption
                        }}
                    />
                </div>
            </div>

            {/* <div className="mb-2 form-field">
                <label>Branch</label>
                <div>
                    <SelectSearch
                        id="ddnBranch"
                        name="ddnBranch"
                        value={selectedBranch}
                        options={branches}
                        onChange={onBranchSelect}
                        search
                        filterOptions={fuzzySearch}
                    >
                    </SelectSearch>
                </div>
            </div> */}

            <div className="mb-2 form-field">
                <div id="branch-error" className="text-danger"></div>
                <label>Branch</label>
                <label id="branch-highlight" className="text-danger">*</label>
                <div>
                    <Select
                        defaultValue={[]}
                        value={selectedBranch}
                        isMulti
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        onChange={handleBranchChange}
                        options={branchOptions}
                        components={{
                            Option: InputOption
                        }}
                    />
                </div>
            </div>

            <div className="mb-2 form-field">
                <div id="fesd-error" className="text-danger"></div>
                <label>From Ship Date</label>
                <label id="fesd-highlight" className="text-danger">*</label>
                <div>
                    {/* <input type="date" className="form-control form-control-sm" defaultValue={defaultFromValue} onChange={selectFromDate}></input> */}
                    <DatePicker
                        value={fromShipDate}
                        onChange={selectFromShipDate}
                        calendarIcon={<i className='fas fa-calendar-alt'></i>}
                        format="MM/dd/yyyy"
                        fixedHeight
                        openCalendarOnFocus={false}
                    />
                </div>
            </div>
            <div className="mb-2 form-field">
                <div id="tesd-error" className="text-danger"></div>
                <label>To Ship Date</label>
                <label id="tesd-highlight" className="text-danger">*</label>
                <div>
                    {/* <input type="date" className="form-control form-control-sm" defaultValue={defaultToValue} onChange={selectToDate}></input> */}
                    <DatePicker
                        value={toShipDate}
                        onChange={selectToShipDate}
                        calendarIcon={<i className='fas fa-calendar-alt'></i>}
                        format="MM/dd/yyyy"
                        fixedHeight
                        openCalendarOnFocus={false}
                    />
                </div>
            </div>
            <div className="mb-2 form-field">
                <div id="fed-error" className="text-danger"></div>
                <label>From Entry Date</label>
                <label id="fed-highlight" className="text-danger">*</label>
                <div>
                    {/* <input type="date" className="form-control form-control-sm" defaultValue={defaultFromValue} onChange={selectFromDate}></input> */}
                    <DatePicker
                        value={fromDate}
                        onChange={selectFromDate}
                        calendarIcon={<i className='fas fa-calendar-alt'></i>}
                        format="MM/dd/yyyy"
                        fixedHeight
                        openCalendarOnFocus={false}
                    />
                </div>
            </div>
            <div className="mb-2 form-field">
                <div id="ted-error" className="text-danger"></div>
                <label>To Entry Date</label>
                <label id="ted-highlight" className="text-danger">*</label>
                <div>
                    {/* <input type="date" className="form-control form-control-sm" defaultValue={defaultToValue} onChange={selectToDate}></input> */}
                    <DatePicker
                        value={toDate}
                        onChange={selectToDate}
                        calendarIcon={<i className='fas fa-calendar-alt'></i>}
                        format="MM/dd/yyyy"
                        fixedHeight
                        openCalendarOnFocus={false}
                    />
                </div>
            </div>
            {/* <div className="mb-3 form-field">
                <label>Report Name</label>
                <div>
                    <input id="reportname" className="form-control form-control-sm" placeholder="F068" onChange={selectReportName}></input>
                </div>
            </div> */}
            <div className="mb-3 form-check">
                <input id='myCheckbox' className='form-check-input' type='checkbox' checked={selectedExcludeRateAndRouteAnalysis === 'Y'} onChange={handleChange} />
                <label>Exclude Rate and Route Analysis</label>
                {/* <div>
                    <FormCheckInput id="exRateAndRouteAnalysis" className="form-control form-control-sm"></FormCheckInput>
                </div> */}
            </div>
            <div className="form-field mx-auto" style={{ width: "180px" }}>
                <button type="button" onClick={ClearFilter} className='btn btn-clear'>Clear</button>
                <button type="button" onClick={LoadBills} className='btn btn-filter ms-2'>Filter</button>
            </div>
        </>
    )
}
